export default "__VITE_ASSET__78557835__"